import React, { useContext, createContext, useState } from "react";
import { ITripDateRange } from "../types/TripTypes";
import {
  ITransactionDetails,
  RefundReasons,
  defaultBillingDateRange,
  defaultFilteredTransactionTypes,
  defaultTransactionDetails,
} from "../types/PaymentTransactionTypes";

const BillingHistoryContext = createContext<any | undefined>(undefined);

export const useBillingHistoryCtx = () => useContext(BillingHistoryContext);

export const BillingHistoryProvider: React.FC = ({ children }) => {
  const [billingHistory, setBillingHistory] = useState<ITransactionDetails[]>([
    defaultTransactionDetails,
  ]);
  const [dateRange, setDateRange] = useState<ITripDateRange>(
    defaultBillingDateRange
  );
  const [checkedTransactionTypes, setCheckedTransactionTypes] = useState<
    Set<string>
  >(new Set(["All"]));
  const [filteredTransactionTypes, setFilteredTransactionTypes] = useState<
    number[]
  >(defaultFilteredTransactionTypes);
  const [refundTransactionReasons, setRefundTransactionReasons] = useState<
    RefundReasons[]
  >();
  const [forceRefetch, setForceRefetch] = useState<boolean>(false);

  const resetDefaults = () => {
    setCheckedTransactionTypes(new Set(["All"]));
    setFilteredTransactionTypes(defaultFilteredTransactionTypes);
    setDateRange(defaultBillingDateRange);
  };

  return (
    <BillingHistoryContext.Provider
      value={{
        billingHistoryCtx: [billingHistory, setBillingHistory],
        dateRangeCtx: [dateRange, setDateRange],
        checkedTransactionTypesCtx: [
          checkedTransactionTypes,
          setCheckedTransactionTypes,
        ],
        filteredTransactionTypesCtx: [
          filteredTransactionTypes,
          setFilteredTransactionTypes,
        ],
        refundTransactionReasonsCtx: [
          refundTransactionReasons,
          setRefundTransactionReasons,
        ],
        billingHistoryForceRefetchCtx: [forceRefetch, setForceRefetch],
        resetDefaults
      }}
    >
      {children}
    </BillingHistoryContext.Provider>
  );
};
